import BasicContentInteractiveMap from './BasicContentInteractiveMap';

export { type BasicContentInteractiveMapProps } from './BasicContentInteractiveMap';
export default BasicContentInteractiveMap;
